import styled from 'styled-components';
import { GridWrapper } from '@nkr/views/admin/crm/products/styles';

export const MicrositesGridWrapper = styled(GridWrapper)`
    .action-menu {
        line-height: normal;
    }

    .action-menu > .ag-react-container {
        line-height: normal;
    }
`;

export const DropdownWrapper = styled.div`
    li.dropdown-header {
        font-size: 16px !important;
    }

    li > a {
        padding-left: 30px;
    }
`;